class RadioBtnWithInput
  constructor: (@container) ->
    @radiobuttons = @container.find('input[name=amount]')
    @checkChooseType()
    @radiobuttons.click =>
      @checkChooseType()

  checkChooseType: ->
    checked = @container.find("input[name=amount]:checked").val()
    if checked != undefined && parseInt(checked) == 0
      $('#amount_custom').attr('min', 5)
      $('#amount_custom').attr('required', 'required')
      $('#amount_custom').removeAttr('disabled')
    else
      $('#amount_custom').removeAttr('min')
      $('#amount_custom').removeAttr('required')
      $('#amount_custom').attr('disabled', 'disabled')

$(window).on "load", ->
  $("*[data-behavior=RadioBtnWithInput]").each ->
    new RadioBtnWithInput($(@))
